import React, { ReactNode } from 'react';
import { authStore } from '../../store/auth.store';

interface PermissionGateProps {
  permission: string | string[];
  requireAll?: boolean;
  fallback?: ReactNode;
  children: ReactNode;
}

const PermissionGate: React.FC<PermissionGateProps> = ({
                                                         permission,
                                                         requireAll = false,
                                                         fallback = null,
                                                         children
                                                       }) => {
  // Use the hasPermission method from your auth store
  const hasPermission = authStore(state =>
    state.hasPermission(permission, { requireAll })
  );

  return hasPermission ? <>{children}</> : <>{fallback}</>;
};

export default PermissionGate;
